export enum BoardPageFiltersType {
    All = 'all',
    Routes = 'routes',
    Breweries = 'breweries',
    Brews = 'brews',
}
